import React from 'react'
import Switch from '@mui/material/Switch'

import './styles.scss'

/**
 * Toggle
 * @param {object} props
 * @param {string} props.label
 * @param {function} props.onClick
 * @param {boolean} [props.disabled]
 * @param {string} [props.className]
 *
 * @returns {React.Component}
 */
const Toggle = (props) => {
  const { disabled = false, value = false, onClick, className = '' } = props

  return (
    <Switch
      disabled={disabled}
      onClick={({ target: { checked } }) => onClick(checked)}
      checked={!!value}
      className={`nx-toggle ${className}`}
    />
  )
}

export default Toggle
